/**
 * liveScreenPresence — l'écran du live de l'élève (design system) est-il rendu ?
 *
 * Les écouteurs globaux de la salle (`common/livekit/components-web/LKEvents.tsx`,
 * `common/hooks/livekit/useLiveKitEventListener.js`) restent montés pour toute l'app : ils servent le
 * tuteur et l'élève dont l'interrupteur est éteint. Quand cet écran est là, c'est lui qui joue les
 * sons, les bandeaux et la navigation du live ; les écouteurs le lisent ici pour ne pas les jouer en
 * double. Éteint, ce registre reste à zéro et rien ne change.
 */
import { createPresenceCount } from "../../../data/utility/presenceCount"

const screens = createPresenceCount()

/** L'écran du live de l'élève se monte : rend la fonction qui le démonte. */
export const markStudentLiveScreen: () => () => void = screens.hold

/** Vrai quand l'écran du live de l'élève est rendu : les écouteurs globaux se taisent. */
export const isStudentLiveScreenMounted: () => boolean = screens.held
